var Component = require("!../../../../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../vue-loader/lib/selector?type=script&index=0!./table.vue"),
  /* template */
  require("!!../../../../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-47a4d2c2\"}!../../../../../../vue-loader/lib/selector?type=template&index=0!./table.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-xpc/src/element-ui/packages/table/src/table.vue
// module id = 1987
// module chunks = 228